import { render, staticRenderFns } from "./Start1.vue?vue&type=template&id=4499a79d&"
import script from "./Start1.vue?vue&type=script&lang=js&"
export * from "./Start1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports